import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InspectionPercentageCase } from '@authority-labs/api-interfaces';
import { CheckBasicCaseComponent } from '../check-basic-case/check-basic-case.component';

@Component({
  selector: 'authority-labs-check-percentage-case',
  templateUrl: './check-percentage-case.component.html',
  styleUrls: ['./check-percentage-case.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckPercentageCaseComponent extends CheckBasicCaseComponent {
  @Input() inspection: InspectionPercentageCase;
}
